import {useNavigate} from 'react-router-dom';
import noImage from '../../../assets/image/newShop/defaultImg.png';

interface IProps {
  cardDetailData: IShopCardDetail;
}

const BrandsSection = ({cardDetailData}: IProps) => {
  const navigate = useNavigate();

  return (
    <div className="py-2 pb-4 ">
      <div className="px-4 mt-2 mb-3 text-gray-800">
        <span>برندهای این فروشگاه</span>
      </div>
      <div className="flex items-center justify-start w-full gap-3 px-4 mt-2 overflow-x-auto bg-farm-shop-50 min-h-24 hideScrollbar">
        {cardDetailData?.store_brands.map(brand => (
          <img
            src={brand.logo ?? noImage}
            alt={brand.name}
            key={brand.id}
            className="object-cover w-16 h-16 border-2 rounded-full min-w-16 border-green-main"
            onClick={() => navigate(`/brand/${brand.id}`)}
          />
        ))}
      </div>
    </div>
  );
};

export default BrandsSection;
